declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '1348863570412843'

let initialized = false

function loadPixelScript() {
  if (initialized) return

  const f = window
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  initialized = true
}

export function initMetaPixel() {
  loadPixelScript()
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  initMetaPixel()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  initMetaPixel()
  window.fbq('track', 'AddToCart', {
    content_name: 'Renacer en 7 Días - Guía Maestra',
    content_type: 'product',
    value: 6.3,
    currency: 'USD',
  })
}
